module.exports = __webpack_public_path__ + "img/file-chain.2a82c62a.svg";